export default "__VITE_ASSET__DmHDYktq__"